'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._encodeData = _encodeData;
exports._decodeData = _decodeData;
exports.getSessionData = getSessionData;
exports.setSessionData = setSessionData;
/* global sessionStorage */

function _encodeData(data) {
  return JSON.stringify(data);
}

function _decodeData(str) {
  return JSON.parse(str);
}
/**
 * Gets a session data and decodes the base64 JSON data.
 *
 * @param name {string}
 */


function getSessionData(name) {
  var str = void 0;

  try {
    str = sessionStorage.getItem(name);
  } catch (error) {
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.error('SessionStorage error: ' + error);
    }
  }

  if (str && str !== '') {
    return _decodeData(str);
  }

  return null;
}
/**
 * Sets a session data and encodes the data as base64 encoded JSON.
 *
 * @param name {string}
 * @param data {object}
 */


function setSessionData(name, data) {
  try {
    sessionStorage.setItem(name, _encodeData(data));
  } catch (error) {
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.error('SessionStorage error: ' + error);
    }
  }
}